import { Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";
import { Linkify } from "@/components/Linkify";

async function downloadCert(d) {
  try {
    const res = await api.get(`/redemptions/${d.id}/certificate`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    const ext = res.data.type === "application/pdf" ? "pdf" : (res.data.type.split("/")[1] || "png");
    a.href = url; a.download = `сертификат-${d.title}.${ext}`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) { toast.error(errText(e)); }
}

export function RedemptionView({ d }) {
  return (
    <div className="space-y-3">
      <RedemptionBody d={d} />
      {d.activation && (
        <div className="rounded-xl bg-[#f3f9f5] border border-[#d1e7dd] p-3" data-testid={`redemption-activation-${d.id}`}>
          <div className="text-xs font-bold uppercase tracking-wider text-[#2e7d56] mb-1">Как активировать</div>
          <p className="text-sm text-[#0b2e20] whitespace-pre-wrap break-words"><Linkify text={d.activation} /></p>
        </div>
      )}
    </div>
  );
}

function RedemptionBody({ d }) {
  if (d.reward_type === "promo") {
    return (
      <div className="flex items-center gap-2">
        <code className="flex-1 px-3 py-2 rounded-lg bg-[#e8f5ed] border border-dashed border-[#2e7d56] font-mono font-bold text-[#0b2e20] break-all" data-testid={`redemption-code-${d.id}`}>{d.code}</code>
        <button onClick={() => { navigator.clipboard?.writeText(d.code); toast.success("Промокод скопирован"); }}
          className="h-9 w-9 grid place-items-center rounded-full text-[#1f5f42] hover:bg-[#e8f5ed]" data-testid={`copy-code-${d.id}`}><Copy className="h-4 w-4" /></button>
      </div>
    );
  }
  if (d.reward_type === "certificate") {
    return (
      <button onClick={() => downloadCert(d)} data-testid={`download-certificate-${d.id}`}
        className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-[#1f5f42] text-white text-sm font-semibold hover:bg-[#174731]">
        <Download className="h-4 w-4" />Скачать сертификат
      </button>
    );
  }
  return <p className="text-sm text-[#1f5f42]" data-testid={`redemption-gift-${d.id}`}><Linkify text={d.delivery_method || "Подарок оформлен. Администратор свяжется с вами."} /></p>;
}
